import { Box } from "@mui/material";

import { styled } from "@mui/material/styles";
import { CellContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

const FlexCenter = styled("div")({
  display: "flex",
  justifyContent: "center",
});

const TextCenter = styled("div")(({ theme }) => ({
  fontSize: 14,
  color: theme.vars.palette.text.primary,
  margin: 0,
  padding: 0,
  textAlign: "center",
}));

const Chip = styled("div")(({ theme }) => ({
  borderRadius: 16,
  color: theme.vars.palette.text.primary,
  fontSize: 14,
  width: 70,
  textAlign: "center",
  padding: "2px 12px",
  borderWidth: 1,
  borderStyle: "solid",
}));

const ChipOnline = styled(Chip)(({ theme }) => ({
  background: theme.vars.palette.backgrounds.success.moderate.default,
  borderColor: theme.vars.palette.borders.success.subtle,
  color: theme.vars.palette.texts.success.default,
}));

const ChipOffline = styled(Chip)(({ theme }) => ({
  background: theme.vars.palette.backgrounds.danger.moderate.default,
  borderColor: theme.vars.palette.borders.danger.subtle,
  color: theme.vars.palette.texts.danger.default,
}));

const ChipMale = styled(Chip)(({ theme }) => ({
  background: theme.vars.palette.backgrounds.info.moderate.default,
  borderColor: theme.vars.palette.borders.info.default,
  color: theme.vars.palette.texts.info.default,
}));

const ChipFemale = styled(Chip)(({ theme }) => ({
  background: theme.vars.palette.backgrounds.warning.moderate.default,
  borderColor: theme.vars.palette.borders.warning.default,
  color: theme.vars.palette.texts.warning.default,
}));

export function DeviceStatus<T extends { deviceStatus: boolean | null }>(
  cell: CellContext<T, boolean | null>,
) {
  const { t } = useTranslation();

  const deviceStatus = cell.getValue();

  return (
    <FlexCenter>
      {deviceStatus === null && <TextCenter>-</TextCenter>}
      {deviceStatus === false && <ChipOffline>{t("offline")}</ChipOffline>}
      {deviceStatus === true && <ChipOnline>{t("online")}</ChipOnline>}
      <Box sx={{ width: "24px", visibility: "hidden" }} />
    </FlexCenter>
  );
}

export function Sex<T extends { sex: string | null }>(
  cell: CellContext<T, string | null>,
) {
  const { t } = useTranslation();

  const gender = cell.getValue();

  if (gender === "male") {
    return (
      <FlexCenter>
        <ChipMale>{t("Male")}</ChipMale>
        <Box sx={{ width: "24px", visibility: "hidden" }} />
      </FlexCenter>
    );
  }

  if (gender === "female") {
    return (
      <FlexCenter>
        <ChipFemale>{t("Female")}</ChipFemale>
        <Box sx={{ width: "24px", visibility: "hidden" }} />
      </FlexCenter>
    );
  }

  return <></>;
}
